import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  ExportButton,
  TextInput,
  DateField,
  BulkDeleteButton,
  useNotify,
} from 'react-admin';
import { Card, CardContent, Button, Box } from '@mui/material';
import DeleteWithConfirmButton from "../../components/DeleteWithConfirmButton.tsx";
import UploadButton from '../../components/UploadButton.tsx';
import TemplateDownloadButton from '../../components/TemplateDownloadButton.tsx';
import BarChartIcon from '@mui/icons-material/BarChart';
import { useNavigate } from 'react-router-dom';
const stockFilters = [
  <TextInput sx={{
    '& .MuiInputBase-input': {
      height: 40,      // 输入框高度
      padding: '6px 12px',
      fontSize: 14,
      lineHeight: '40px', // 使文字垂直居中
    },
    minHeight: 36,      // 整体高度
    marginBottom: '16px',
  }} label="Search For Product ID" source="productId" alwaysOn resettable />,

];
const ListActions = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

  const notify = useNotify();
  const fetchSAPInventoryData = async () => {
    // 立即通知用户操作已开始
    notify("SAP Inventory 数据获取已开始，稍后将通过邮件通知结果", { type: "info" });

    try {
      const token = localStorage.getItem("token"); // 获取 token
      await fetch(`${API_URL}/stock/sap`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`, // 添加 Authorization 头
        },
      });

      // 不需要等待接口完成后再通知用户
    } catch (error) {
      console.error(error);
      notify("获取 SAP Inventory 数据失败，请稍后重试", { type: "error" });
    }
  };
  return (
    <TopToolbar sx={{ marginBottom: '16px', }}>
      <Button
        variant="contained"
        color="primary"
        onClick={fetchSAPInventoryData}
        sx={{ textTransform: "capitalize", marginRight: "8px" }}
      >
        Call SAP API
      </Button>
      <TemplateDownloadButton href="/templates/stock_template.csv" />
      <UploadButton resource="stock" onSuccess={() => window.location.reload()} />
      <ExportButton sx={{
        textTransform: 'capitalize', '&.css-istbiy-MuiButtonBase-root-MuiButton-root': {
          marginLeft: '0 !important', // 强制覆盖
        }, top: '-5px', '& span': {

          marginRight: '2px',

        }, ml: 0,
      }} />
      <CreateButton label="New Inventory" sx={{
        top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();
  if (!record) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%' }}>
      {/* <Button
        color="primary"
        size="small"
        startIcon={<BarChartIcon />}
        sx={{ textTransform: 'capitalize', minWidth: 'auto' }}
        onClick={e => { e.stopPropagation(); navigate(`/sales/${record.id}/chart`); }}
      >
        Chart
      </Button> */}
      <EditButton record={record} sx={{
        textTransform: 'capitalize', '& span': {

          marginRight: '2px',

        }
      }} />
      <DeleteWithConfirmButton record={record} resource="stock" />
    </div>
  );
};
const StockList = (props) => (

  <List
    sx={{ marginTop: '20px', padding: '0 16px' }}
    empty={false}
    filters={stockFilters}
    {...props} actions={<ListActions />}>

    {/* <Box sx={{
      maxWidth: 'calc(100vw - 290px)', // 减去 Sidebar 宽度
      overflowX: 'auto',
    }}>
      <Box sx={{}}> */}
    <Datagrid rowClick={false} isRowSelectable={() => true} bulkActionButtons={<BulkDeleteButton label="批量删除" />} sx={{

      '& .RaDatagrid-headerCell': {
        textAlign: 'center',
      },
      '& .RaDatagrid-rowCell': {
        textAlign: 'center',
      },
    }}>
      <TextField source="id" label="Id" />
      <TextField source="product.productId" label="ProductId" />
      <TextField source="product.name" label="ProductName" />
      <TextField source="quantity" label="quantity" />
      <TextField source="product.unit" label="Unit" />
      <FunctionField label="Operations" render={record => <ActionButtons record={record} />} />

    </Datagrid>
    {/* </Box>
    </Box> */}
  </List >
);

export default StockList;
